import React from 'react';
import WaterBalanceCulture from 'views/Meteorology/Agro/WaterBalanceCulture';
import DetailedView from 'views/Meteorology/Agro/WaterBalanceCulture/DetailedView';

const waterBalanceCultureRouter = {
  path: 'water-balance-culture',
  element: <WaterBalanceCulture />,
  children: [
    { path: '', element: <DetailedView /> },
  ],
};

export default waterBalanceCultureRouter;
